import {NavLink, useParams} from 'react-router-dom';
import {CalendarCheck, GridFour, House} from '@phosphor-icons/react';
import {tenantPath} from '@/lib/tenant/resolve';
import {cn} from '@/lib/utils';

const ITEMS = [
  {to: '', label: 'Главная', icon: House, end: true},
  {to: 'services', label: 'Услуги', icon: GridFour, end: false},
  {to: 'booking', label: 'Моя запись', icon: CalendarCheck, end: false},
] as const;

/** Плавающая стеклянная панель: иконка над подписью, активный пункт подсвечен светлой «таблеткой». */
export function BottomNav() {
  const {slug = ''} = useParams();
  return (
    <nav aria-label="Основная навигация" className="pb-safe fixed inset-x-0 bottom-0 z-40 px-4">
      <div className="nav-pill mx-auto mb-3 flex items-stretch gap-1 rounded-full p-1.5 lg:mb-6 lg:max-w-[360px]">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.label}
              to={tenantPath(slug, item.to)}
              end={item.end}
              className={({isActive}) =>
                cn(
                  'flex flex-1 flex-col items-center justify-center gap-0.5 rounded-full py-2 transition-colors',
                  isActive ? 'bg-white/15 text-foreground' : 'text-foreground/75',
                )
              }
            >
              <Icon size={24} weight="fill" aria-hidden />
              <span className="text-[14px] font-semibold leading-tight">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
